import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=0734d709&scoped=true"
import script from "./table-header.vue?vue&type=script&lang=ts"
export * from "./table-header.vue?vue&type=script&lang=ts"
import style0 from "./table-header.vue?vue&type=style&index=0&id=0734d709&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0734d709",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0734d709')) {
      api.createRecord('0734d709', component.options)
    } else {
      api.reload('0734d709', component.options)
    }
    module.hot.accept("./table-header.vue?vue&type=template&id=0734d709&scoped=true", function () {
      api.rerender('0734d709', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/benchmarking-table/header-types/table-header.vue"
export default component.exports